// @flow

import * as React from "react";
import cx from "classnames";

import type { InputType } from "../Input/TextInput";

import styles from "./RadioButton.scss";

type RadioButtonProps = {
  id: string,
  label: string,
  value: string,
  checked: boolean,
  input: InputType,
  isDisabled: boolean
};

const handleClick = ({ value, onChange, onFocus, isDisabled }) => {
  if (isDisabled) {
    return;
  }

  onChange(value);
  onFocus();
};

const RadioButton = ({ id, label, value, checked, input, isDisabled }: RadioButtonProps) => {
  const { onChange, onBlur, onFocus } = input;

  return (
    <label
      htmlFor={id}
      className={cx({ [styles.disabled]: isDisabled }, styles.container)}
      data-testid={`radioLabel:${input.name}-${String(value)}`}
    >
      <button
        type="button"
        id={id}
        value={value}
        className={cx(styles.radio, { [styles.checked]: checked })}
        onClick={() => handleClick({ value, onChange, onFocus, isDisabled })}
        onFocus={onFocus}
        onBlur={onBlur}
        role="radio"
        aria-checked={checked}
        data-value={value}
        data-testid={`radioButton:${input.name}-${String(value)}`}
        data-name={input.name}
        disabled={isDisabled}
      />
      {/* Span element is a label which should just be clickable. No reason to make it a button. */}
      <span // eslint-disable-line
        onClick={() => handleClick({ value, onChange, onFocus, isDisabled })}
        className={cx(styles.text, {
          [styles.textChecked]: checked,
          [styles.disabledText]: isDisabled
        })}
      >
        {label}
      </span>
    </label>
  );
};

export default RadioButton;
